module.exports = __webpack_public_path__ + "img/gh-40370-2.prt.49683720.jpg";